<template>
  <div class="alert-management_container">
    <organism-alert-management
      :alertData="alertData"
      @toggleAlert="toggleAlert"
    ></organism-alert-management>
  </div>
</template>

<script>
import OrganismAlertManagement from "@/components/organisms/OrganismAlertManagement.vue"
import { getAlertManagement, enableAlertManagementById } from "@/api/api-module"
import mixins from "@/mixins"
export default {
  name: "AlertManagement",
  components: {
    OrganismAlertManagement,
  },
  mixins: [mixins],
  data() {
    return {
      alertData: [],
    }
  },
  mounted() {
    this.showLoading(true)
    this.getAlertList()
  },
  methods: {
    async getAlertList() {
      this.showLoading(true)
      this.alertData = []
      await getAlertManagement()
        .then((response) => {
          response.forEach((alert) => {
            this.alertData.push({
              alertCount: alert.alertMaxEventCount,
              alertDescription: alert.alertDescription,
              alertInterval: alert.alertThresholdInterval,
              alertName: alert.alertName,
              email: alert.alertEmails,
              id: alert.alertId,
              isAlertThresholdEnable: alert.alertThresholdEnable,
              isEnabled: alert.alertEnable,
              line: alert.alertLines,
              monitorCount: alert.alertEquipmentCount,
              path: alert.alertSMSGatewayPath,
              sms: alert.alertSmses,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    // enable alert management by id
    async toggleAlert(id) {
      const isEnable = this.alertData.find((alert) => alert.id === id).isEnabled
      const toStatus = isEnable ? "Disabled" : "Enabled"
      this.showLoading(true)
      const response = await enableAlertManagementById(id)
      this.getAlertList()
      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess(toStatus + " successfully")
      } else {
        this.toastError(toStatus + " failed")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.alert-management_container {
  padding-bottom: 5px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .alert-management_container {
    padding-bottom: 0;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
